import { createContext } from "react";
import { ITranslate } from "./models/ITranslate";

//context
export const TranslateContext = createContext<ITranslate>({} as ITranslate);
export const TranslateStateContext = createContext<any>({});
export const TranslateDispatchContext = createContext<any>({});